module.exports = __webpack_public_path__ + "img/guide-dialog.9440b3f8.png";